import React from 'react';
import RightSidebarForm from 'Views/Page/Content/RightSidebar/Content/RightSidebarForm';
import PropTypes from 'prop-types';
import LeversSidebarLayout from './leversSidebarLayout';
import metaOverrideSet from '../DefaultTemplate/MetaOverrideSet';

const RoadmapExplorerLeversTemplate = ({
  collection,
  ...rest
}) => {
  return (
    <RightSidebarForm
      Layout={LeversSidebarLayout}
      collection={collection}
      metaOverrideSet={metaOverrideSet}
      LayoutProps={{ ...rest }}
    />
  );
};

RoadmapExplorerLeversTemplate.propTypes = {
  collection: PropTypes.object.isRequired,
  rest: PropTypes.object,
};

export default RoadmapExplorerLeversTemplate;
